<!-- `min-h-full` rather than `h-full`: the host scrolls vertically now, so the grid has to
     be free to grow past it, while still filling it when the rows fall short — otherwise
     the sticky summary rides up under the last row instead of sitting at the bottom. -->
<div role="table" class="bg-elevated flex min-h-full min-w-max flex-col">
  <app-table-header
    class="bg-elevated sticky top-0 z-10 block flex-none"
    [tableId]="tableId()"
    [config]="config()"
    [columns]="columns()"
    [tableColumnStyles]="getTableStyles()"
    [hasActions]="actions().length > 0"
    [hiddenColumns]="getHiddenColumns()"
    [onSort]="onSort.bind(this)"
    [removeSort]="removeSort.bind(this)"
    [toggleSelection]="toggleSelection.bind(this)"
    [isAllRowSelected]="isAllRowSelected()"
    [isAnySelectedRow]="isAnySelectedRow()"
    (removeFilterOn)="removeFilterOn.emit($event)"
    (addFilterOn)="addFilterOn.emit($event)" />

  <!-- `flex-1` without `min-h-0`: it grows to fill a short table, but the automatic
       minimum keeps it from being squeezed below the height the CDK spacer sets. -->
  <app-table-content
    class="flex-1"
    [tableId]="tableId()"
    [data]="sortedData()"
    [config]="config()"
    [columns]="columns()"
    [ownerEntityType]="ownerEntityType()"
    [actions]="actions()"
    [errors]="errors()"
    [pendingRowUids]="pendingRowUids()"
    [cellOptions]="cellOptions()"
    [referenceNames]="referenceNames()"
    [isThereHiddenColumns]="getHiddenColumns().length > 0"
    [tableColumnStyles]="getTableStyles()"
    [selected]="selected()"
    (rowEdit)="rowEdit.emit($event)"
    (listItemClick)="listItemClick.emit($event)"
    (goToReference)="goToReference.emit($event)"
    (showDetails)="showDetails.emit($event)" />

  @if (hasSummaryData()) {
    <app-table-summary
      class="bg-surface sticky bottom-0 z-10 block flex-none"
      [unusedLeftColumns]="getUnusedLeftColumnsCount()"
      [unusedRightColumns]="getUnusedRightColumnsCount()"
      [columns]="columns()"
      [summaryItems]="summaryItems()"
      [tableColumnStyles]="getTableStyles()" />
  }
</div>
